import { render, staticRenderFns } from "./TicketsRoutefix.vue?vue&type=template&id=2b11de32&"
import script from "./TicketsRoutefix.vue?vue&type=script&lang=js&"
export * from "./TicketsRoutefix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports